import Keycloak from "keycloak-js";

/**
 * Instancia singleton de Keycloak.
 *
 * IMPORTANTE: se crea a nivel de módulo (no dentro de un componente) porque
 * keycloak-js NO admite múltiples instancias contra el mismo realm. Si la
 * pusiéramos dentro de un componente, React Strict Mode (que monta y desmonta
 * componentes dos veces en dev) crearía dos instancias y rompería el init.
 *
 * Los valores vienen de variables Vite (VITE_*), que se reemplazan en build
 * time con los strings reales del .env.
 */
const keycloakClient = new Keycloak({
  url: import.meta.env.VITE_KEYCLOAK_URL,
  realm: import.meta.env.VITE_KEYCLOAK_REALM,
  clientId: import.meta.env.VITE_KEYCLOAK_CLIENT_ID,
});

export default keycloakClient;
